import React from 'react';
import { useRouter } from 'next/compat/router';
import { useObserver } from 'mobx-react-lite';

import useStores from 'shared/hooks/use-stores';
import Wrapper from 'components/wrapper';
import MetaTags from 'components/meta-tags';
import { useViewedCheckoutMonitor } from 'utils/analytics';
import { useViewedCheckoutAnalytics } from 'hooks/use-ecommerce-analytics';
import { CheckoutProvider, contextStore } from 'checkout/context';

import CheckoutContainer from 'checkout/container';
import useConsumerChatWidget from 'shared/hooks/use-consumer-chat-widget';
import { IsolatedCheckoutProvider } from 'checkout/isolated/context';
import { AerosyncPreAuthProvider } from 'src/payments/components/aerosync-pre-auth/context/aerosync-pre-auth-provider';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import CriticalAnnouncementModal from 'components/modals/critical-announcement-modal/critical-announcement-modal';
import useCriticalAnnouncementModal from 'hooks/use-critical-announcement-modal';

function CheckoutPage() {
  const stores = useStores();
  const { Cart } = stores;
  const isCartReady = useObserver(() => Cart?.isReady);
  const { isReady } = useRouter() ?? {};
  const {
    showModal: showAnnouncementModal,
    modalConfig,
    closeModal: closeAnnouncementModal,
  } = useCriticalAnnouncementModal();

  useConsumerChatWidget();
  useViewedCheckoutMonitor();
  useViewedCheckoutAnalytics({ cart: stores.cart });

  if (stores.UI) {
    contextStore.showErnie = stores.UI.showErnie;
    contextStore.variant = stores.UI.variant;
    contextStore.openOrderTypeModal = stores.UI.openOrderTypeModal;
  }

  return (
    <Wrapper>
      <MetaTags customRobotsRule='noindex,nofollow' />
      {isReady && isCartReady && (
        <CheckoutProvider value={contextStore}>
          <IsolatedCheckoutProvider value={{ loading: false }}>
            <AerosyncPreAuthProvider>
              <CheckoutContainer />
            </AerosyncPreAuthProvider>
          </IsolatedCheckoutProvider>
        </CheckoutProvider>
      )}

      {/* Critical Announcement Modal */}
      <ModalWrapper open={showAnnouncementModal} onClose={closeAnnouncementModal}>
        <CriticalAnnouncementModal containerProps={{}} onClose={closeAnnouncementModal} config={modalConfig} />
      </ModalWrapper>
    </Wrapper>
  );
}

CheckoutPage.hideAppHeader = true;
CheckoutPage.hideAppFooter = true;

export default CheckoutPage;
